
export default function servicesList () {

	const section = document.querySelector('section.services-list');

	if (! section) return;

	const accordion = section.querySelector('.accordion');
	const tabs = section.querySelector('.tabs');

	if (! accordion || ! tabs) return;



	// Init swiper with tabs
	const swiperEl = section.querySelector('.swiper:not(.swiper-initialized)');

	if (swiperEl) {
		new Swiper (swiperEl, {
			loop: false,
			spaceBetween: 24,
			breakpoints: {
				0:    { slidesPerView: 2, centeredSlides: true },
				450:  { slidesPerView: 2, centeredSlides: false },
				600:  { slidesPerView: 3 },
				768:  { slidesPerView: 4 },
			},
			pagination: {
				el: section.querySelector('.swiper-pagination'),
				type: 'progressbar',
			},
			navigation: {
				prevEl: section.querySelector('.swipe-prev'),
				nextEl: section.querySelector('.swipe-next'),
			},
		});
	}



	function screen () {
		if (window.innerWidth < 768) {
			return 'mobile';
		} else {
			return 'desktop';
		}
	}

	function openPanel () {

		section.classList.add('open');

		accButton.setAttribute('aria-expanded', 'true');
		accContent.setAttribute('aria-hidden', 'false');

		// height to content height
		accordion.style.height = accordion.scrollHeight + 'px';

		// desktop
		if (screen () === 'desktop') {
			accButton.classList.add('fade');

			// margin-bottom to 0
			accordion.style.marginBottom = '0px';
		}

		// mobile
		if (screen () === 'mobile') {
			// margin-top to 0 (accordion overlaps tabs slider)
			accordion.style.marginTop = '0px';
		}

		// after animation
		accordion.addEventListener('transitionend', function handler() {
			// let height change naturally
			accordion.style.height = 'auto';
			accordion.removeEventListener('transitionend', handler);

			// desktop
			if (screen () === 'desktop') {
				accButton.classList.add('hide');
			}
		});

	}

	function closePanel () {

		section.classList.remove('open');

		accButton.setAttribute('aria-expanded', 'false');
		accContent.setAttribute('aria-hidden', 'true');

		// set current height as a fixed start point
		accordion.style.height = accordion.scrollHeight + 'px';
		// force reflow so the browser registers the current height
		accordion.offsetHeight;

		// height to 0
		accordion.style.height = '0px';

		// mobile
		if (screen () === 'mobile') {
			// margin-top to 560px
			accordion.style.marginTop = '560px';
		}

	}

	const accButton = section.querySelector('#accordion-button');
	const accContent = accordion.querySelector('.accordion-content');

	// Open accordion on acc button click - then button disappears
	accButton.addEventListener('click', function () {
		openPanel ();
	});

	// Open accordion on tab button click too
	tabs.querySelectorAll('button').forEach((el) => {
		el.addEventListener('click', () => {
			if (accButton.getAttribute('aria-expanded') === 'false') {
				openPanel ();
			}
		});
	});

	// Close accordion on close button click - in tab content
	accordion.querySelectorAll('.close').forEach((el) => {
		el.addEventListener('click', () => {
			closePanel ();
		});
	});

}

/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on selection/attribute change) without a page
	reload, so 'DOMContentLoaded' only covers the first render - re-run init
	on every preview refresh too. ACF's block-preview JS runs in the outer
	admin window, while this script runs inside the iframe, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=services-list', servicesList);
}
